module.exports = __webpack_public_path__ + "img/a6e1650.png";